import { css } from 'emotion'
import { SliderLabel, Colors } from '..'

export const UploadStyle = css({
  'input': {
    display: 'none'
  },
  'input + label': {
    ...SliderLabel,
    background: Colors.extraLightGrey,
    color: 'black',
    height: 60,
    lineHeight: '60px',
    margin: '2rem 0',
    display: 'block',
    width: '100%',
    textAlign: 'center',
    transition: 'all 400ms ease',
    cursor: 'pointer',
    '&:hover ': {
      background: 'black',
      color: 'white',
    }
  }
})


// WEBPACK FOOTER //
// ./src/styles/components/uploadFile.js